import React from "react";

function Logo() {
  return <img src={require("../../assets/logo.png")} width={67} alt="logo" />;
}

export default Logo;
